import React from 'react'
import PropTypes from 'prop-types'

function JobActions({
  status, slug, type, applicationId = null,
}) {
  return (
    <div className="jobs-button">
      {status === 'available' ? (
        type === 'public' ? (
          <a href={`3d-modeling-jobs/browse/${slug}/apply`} className="btn btn-primary btn-sm">
            {type === 'private' ? 'View Offer' : 'Apply for this Project' }
          </a>
        ) : (
          <a href={`profile/projects/${slug}`} className="btn btn-primary btn-sm">
            {type === 'initiated_by_buyer' ? 'View Offer' : 'Apply for this Project' }
          </a>
        )
      ) : (
        status === 'applied' ? (
          <span>
            <a href={`/3d-modeling-jobs/browse/${slug}/${applicationId}/edit`} className="btn btn-primary btn-sm u-mr10">
              Edit my offer
            </a>
            <a href={`/profile/projects/${slug}`} className="btn btn-outline-primary btn-sm">
              Take me to my workplace
            </a>
          </span>
        ) : (
          <a href={`/profile/projects/${slug}`} className="btn btn-primary btn-sm">
            Take me to my workplace
          </a>
        )
      )}
    </div>
  )
}

JobActions.propTypes = {
  status: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  applicationId: PropTypes.number,
}

export default JobActions
